import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useUploadPastPaperFile = () => {
  return useMutation((data) => {
    return axiosPost("/api/cw/uploadPastFile", data);
  });
};

export default useUploadPastPaperFile;
